//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
//@end

//@import components
import ResearchItemSkeleton from 'app_components/screens/landing/researchitem/components/researchItemSkeleton';
import PublicAppContainer from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import ContentNewsCommon from 'app_components/commons/contentnews'
import SeparatorHorCommon from 'app_components/commons/separatorhor'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
//@end

// @import hooks
// @end

// @INFO Import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../researchitemScreen.scss'

// @ADD Component types
interface IResearchitemScreenLayoutProps {
  post: IPost | null
  loading: boolean
}

const ResearchitemScreenLayout: React.FC<IResearchitemScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppContainer>
      <BannerTextPrimaryCommon text={'Investigaciones'}/>

      <div className={'research_item-component mb-4'}>
        <Container >
          <Row className="mb-4">
            <Col xs={12} md={12}>
              {props.loading ? (
                <ResearchItemSkeleton />
              ) : (
                <>
                  {props.post ? (
                    <ContentNewsCommon news={props.post}/>
                  ) : (
                    <div className="mt-3">
                      <AlertComponent
                        type='warning'
                        title={t('screens.research.no_data')}
                      />
                    </div>
                  )}
                </>
              )}
            </Col>

          </Row>

          <SeparatorHorCommon/>
        </Container>
      </div>
    </PublicAppContainer>
  )
}

export default ResearchitemScreenLayout
